export default __webpack_public_path__ + "static/media/ahsoka_001.4d4f83f3.jpeg";